import { render, staticRenderFns } from "./TranServicePackageList.vue?vue&type=template&id=6d3a6170&scoped=true"
import script from "./TranServicePackageList.vue?vue&type=script&lang=js"
export * from "./TranServicePackageList.vue?vue&type=script&lang=js"
import style0 from "./TranServicePackageList.vue?vue&type=style&index=0&id=6d3a6170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3a6170",
  null
  
)

export default component.exports